module.exports = __webpack_public_path__ + "img/personal-info-red.039c2003.svg";